import {classes} from '@bitstillery/common/lib/utils'
import {MithrilComponent} from '@bitstillery/mithril'
import m from '@bitstillery/mithril'
import {Tippy} from '../tip/tip'

interface BadgeAttrs {
    type?: 'default' | 'info' | 'success' | 'danger' | 'warning' | 'brand' | (string & {})
    onclick?: (e: MouseEvent) => unknown
    className?: string
    tip?: string
}

export class Badge extends MithrilComponent<BadgeAttrs> {
    view(vn: m.Vnode<BadgeAttrs>) {
        const type = vn.attrs.type || 'default'
        const badge = (
            <span onclick={vn.attrs.onclick} className={classes('c-badge', `type-${type}`, vn.attrs.className)}>
                {vn.children}
            </span>
        )
        return vn.attrs.tip ? <Tippy content={vn.attrs.tip}>{badge}</Tippy> : badge
    }
}
